import { render } from "./FinishedExam.vue?vue&type=template&id=a49a0a34"
import script from "./FinishedExam.vue?vue&type=script&lang=js"
export * from "./FinishedExam.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});qInstall(script, 'directives', {ClosePopup});
